<template>
  <div class="impactCard-body">
    <div class="image-wrapper">
      <img class="image" :src="imageSrc" :alt="title" />
    </div>
    <div class="text-wrapper">
      <div class="title">{{ title }}</div>
      <div class="text">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImpactCard",
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.impactCard-body {
  max-width: 815px;
  height: 615px;
  display: flex;
  flex-direction: column;
}
.image-wrapper {
  width: 100%;
  height: 350px;
}
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
}

.text-wrapper {
  height: 289px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 40px;
  box-sizing: border-box;
}
.title {
  font-size: 30px;
  font-weight: 500;
  color: #000000;
}
.text {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}

@media (max-width: 1720px) {
  .impactCard-body {
    width: 700px;
  }
}
@media (max-width: 1488px) {
  .impactCard-body {
    width: 650px;
  }
}
@media (max-width: 1390px) {
  .impactCard-body {
    width: 596px;
    height: 621px;
  }
  .text-wrapper {
    height: 271px;
  }
  .text {
    font-size: 14px;
  }
}
@media (max-width: 1280px) {
  .impactCard-body {
    width: 468px;
    height: 627px;
  }
  .image-wrapper {
    width: 100%;
    height: 300px;
  }
  .text-wrapper {
    height: 271px;
  }
  .title {
    font-size: 25px;
  }
  .text {
    font-size: 14px;
  }
}
@media (max-width: 1024px) {
  .impactCard-body {
    width: 345px;
    height: 538px;
  }
  .image-wrapper {
    height: 250px;
  }
  .text-wrapper {
    height: 288px;
    padding: 30px 30px 0px 30px;
    gap: 10px;
  }
  .text {
    font-size: 12px;
  }
}
@media (max-width: 778px) {
  .impactCard-body {
    width: 100%;
    height: fit-content;
  }
  .image-wrapper {
    width: 100%;
    height: 180px;
  }
  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 20px;
  }
}
</style>
